import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/Actions/Actions";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext({});

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [auth, setAuth] = React.useState({});
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const loggedInSecondsAgo =
      new Date().getTime() / 1000 - state?.user?.loggedInTimeStamp / 1000;
    if (isNaN(loggedInSecondsAgo) || loggedInSecondsAgo >= 28800) {
      console.log("Logout");
      dispatch(logout(state));
      localStorage.removeItem("63cea11a56a16759beca56461fe85621");
      localStorage.clear();
      navigate("/login");
    }
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
